import { createWebSocketStore } from 'src/components/#services/helpers';
export const getAllMemberships = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_getAll',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getUserMemberships = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_getAllActive',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getMembershipInfo = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_getMembershipInfo',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const addNewMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_add',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const deleteMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_delete',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const deleteUserMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_disable',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const updateMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_update',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const setMembership = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_addAwardMembership',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const changeUserMembershipGame = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_changeMembershipGame',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const updateMembershipsPriorityIndex = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'config_updatePriorityIndex',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getAllActiveByFilter = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_getAllActiveByFilter',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getAllActiveCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'membership_getAllActiveCount',
        agent: 'status',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
